import { Component, OnInit } from '@angular/core';
import {ExternalpageService, externalpageTypes, externalpageImageTypes} from '../../shared/services/externalpage.service';
import {ExternalpageOverview} from '../../class/externalpage-overview';
import {DomainService} from '../../shared/services/domain.service';

@Component({
    selector: 'app-page-projects',
    templateUrl: './page-projects.component.html',
    styleUrls: ['./page-projects.component.scss'],
    standalone: false
})
export class PageProjectsComponent extends ExternalpageOverview implements OnInit {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public nodes :any = [];

  public view = {
    pageType: externalpageTypes.Project,
    queryParams: {
      pageSize: 9,
      pageNumber: 1,
      totalItems: 0
    },
    data: <any[]> [],
  }

  /**
   * Constructor
   *
   * @param ExternalpageService externalpageService
   */
  constructor(
    public externalpageService: ExternalpageService,
    protected domain: DomainService
  ) {

    super(externalpageService, domain);
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.loadData();

  }

}
